module.exports = __webpack_public_path__ + "img/mark-price.ac86c0b0.jpg";